import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddCoupon from "./AddCoupon";
import UpdateCoupon from "./UpdateCoupon";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import UseToggle from "../../../../../Hooks/UseToggle";
import { storeCouponServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCouponServices";
import ToolBar from "../../../../Componant/ToolBar";
import CouponData from "./CouponData";

const CouponManagement = () => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeCouponData, setStoreCouponData] = useState("");
  const [storeCouponCount, setStoreCouponCount] = useState(0);
  const [storeCouponIds, setStoreCouponIds] = useState([]);
  const [couponData, setCouponData] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  const toggleSingle = (id) => {
    setStoreCouponIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeCouponIds.length === storeCategories.length) {
      setStoreCouponIds([]);
    } else {
      setStoreCouponIds(storeCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeCategories.length > 0 &&
    storeCouponIds.length === storeCategories.length;
  const isChecked = (id) => storeCouponIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeCouponCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeCouponCount);

  const getStoreCouponList = async () => {
    setLoader(true);
    let data = await storeCouponServices.getStoreCouponList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreCategories(data?.data || []);
    setStoreCouponCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreCoupon = async (couponId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Coupon?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.couponId = couponId;
        userData.status = status;
        userData.settings = "status";
        let data = await storeCouponServices.updatedStoreCoupon(userData);
        if (data?.statusCode === 200) {
          getStoreCouponList();
        }
      }
    });
  };

  const deleteStoreCoupon = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Coupon?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.couponIds = storeCouponIds;
        let data = await storeCouponServices.deleteStoreCoupon(userData);
        if (data?.statusCode === 200) {
          getStoreCouponList();
        }
      }
    });
  };

  useEffect(() => {
    let storeCouponData = storeCategories?.find(
      (item) => item.couponId === storeCouponIds?.[0],
    );
    setStoreCouponData(storeCouponData || "");
  }, [storeCouponIds]);

  useEffect(() => {
    getStoreCouponList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={storeCouponIds}
        setCheckedIds={setStoreCouponIds}
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        setSelected={setCouponData}
        start={start}
        end={end}
        totalItems={storeCouponCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteStoreCoupon}
        addField
        editField
      />
      <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
        <div
          className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
          style={{ height: "calc(100vh - 106px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th style={{ width: "30%" }}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Coupon</div>
                  </div>
                </th>
                {!couponData && (
                  <>
                    <th>Status</th>
                    <th>Created Date | Time</th>
                    <th>Updated Date | Time</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {storeCategories?.map((item) => (
                <tr
                  key={item.couponId}
                  className={`contact-row ${couponData?.couponId === item.couponId ? "active" : ""}`}
                  onClick={() => {
                    setCouponData(item);
                    setShowPreview(true);
                  }}
                >
                  <td
                    className="text-truncate text-wrap"
                    style={{ maxWidth: 100 }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.couponId)}
                          onChange={() => toggleSingle(item.couponId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                        <small className="text-muted">{item.description}</small>
                      </div>
                    </div>
                  </td>
                  {!couponData && (
                    <>
                      <td>
                        <Form.Check
                          type="switch"
                          onChange={() =>
                            updatedStoreCoupon(
                              item?.couponId,
                              item.status === "active" ? "inactive" : "active",
                            )
                          }
                          checked={item.status === "active"}
                        />
                      </td>
                      <td>
                        <span className="fw-medium">
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.createdAt}
                          </Moment>
                        </span>
                      </td>
                      <td>
                        <span className="fw-medium">
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.updatedAt}
                          </Moment>
                        </span>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className={`preview-section ${showPreview ? "open" : ""}`}>
          {couponData && (
            <div className="overflow-auto" style={{ height: "calc(100vh - 108px)" }}>
              <div className="preview-scroll p-0">
                <div className="preview-block">
                  <CouponData couponData={couponData} getStoreCouponList={getStoreCouponList} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddCoupon
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Coupon`}
        getStoreCouponList={getStoreCouponList}
      />
      <UpdateCoupon
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Coupon`}
        storeCouponData={storeCouponData}
        setStoreCouponData={setStoreCouponData}
        setStoreCouponIds={setStoreCouponIds}
        getStoreCouponList={getStoreCouponList}
      />
    </>
  );
};

export default CouponManagement;
